import { EventEmitter } from "@src/js/utils/EventEmitter";
export var AudioEvents;
(function (AudioEvents) {
    AudioEvents["FINAL"] = "final";
    AudioEvents["INTERIM"] = "interim";
    AudioEvents["SPEAKING"] = "speaking";
    AudioEvents["STOP"] = "stop";
    AudioEvents["START"] = "start";
    AudioEvents["ERROR"] = "error";
    AudioEvents["END"] = "end";
})(AudioEvents || (AudioEvents = {}));
export class AudioInputManager extends EventEmitter {
    constructor(language = 'en-US') {
        super();
        this.language = language;
        this.listening = false;
        this.fullTranscript = '';
        this.transcript = '';
        this.isSpeaking = false;
        const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
        if (!SpeechRecognition) {
            alert('Your browser does not support Speech Recognition. Try Chrome or Edge.');
            throw new Error('Speech Recognition not supported.');
        }
        this.recognition = new SpeechRecognition();
        this.recognition.lang = this.language;
        this.recognition.continuous = true;
        this.recognition.interimResults = true;
        this.recognition.onresult = (event) => {
            let interimTranscript = '';
            this.setSpeaking(true); // 🎤 Detected speech
            for (let i = event.resultIndex; i < event.results.length; ++i) {
                const result = event.results[i];
                const text = result[0].transcript.trim();
                if (result.isFinal) {
                    this.fullTranscript += text + ' ';
                    this.transcript = this.fullTranscript;
                    this.emit(AudioEvents.FINAL, text);
                }
                else {
                    interimTranscript += text;
                    this.emit(AudioEvents.INTERIM, interimTranscript);
                }
            }
            this.resetSpeakingTimeout(); // ⏱️ Restart speaking timer
        };
        this.recognition.onerror = (event) => {
            console.error('[Speech recognition error]', event);
            this.emit(AudioEvents.ERROR, event);
        };
        this.recognition.onend = () => {
            this.emit(AudioEvents.END, undefined);
            if (this.listening) {
                this.recognition.start();
            }
        };
        console.log("AudioInputManager initialized with language:", this.language);
    }
    setSpeaking(value) {
        if (this.isSpeaking !== value) {
            this.isSpeaking = value;
            // console.log(`[AudioInputManager] Speaking status changed: ${this.isSpeaking}`);
            this.emit(AudioEvents.SPEAKING, this.isSpeaking);
        }
    }
    resetSpeakingTimeout() {
        clearTimeout(this.speakingTimeout);
        this.speakingTimeout = setTimeout(() => {
            this.setSpeaking(false); // 🛑 No speech for a while
        }, 200); //
    }
    startListening() {
        this.transcript = '';
        this.recognition.start();
        this.listening = true;
        this.emit(AudioEvents.START, undefined);
    }
    stopListening() {
        this.recognition.stop();
        this.listening = false;
        clearTimeout(this.speakingTimeout);
        this.setSpeaking(false);
        this.emit(AudioEvents.STOP, undefined);
    }
    getTranscript() {
        return this.transcript;
    }
    resetTranscript() {
        this.fullTranscript = '';
        this.transcript = '';
    }
    getIsSpeaking() {
        return this.isSpeaking;
    }
    destroy() {
        if (this.recognition) {
            this.recognition.onresult = null;
            this.recognition.onerror = null;
            this.recognition.onend = null;
            this.recognition.stop(); // stop recognition if running
            this.recognition = null;
        }
        this.listening = false;
        this.fullTranscript = '';
        this.transcript = '';
        clearTimeout(this.speakingTimeout);
        this.setSpeaking(false);
        // Optionally remove all custom event listeners (if your EventEmitter supports it)
        this.removeAllListeners?.();
    }
}
